/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type FormActionsRowProps = {
    left?: React.ReactNode
    right?: React.ReactNode
    className?: string
}

const UiFormActionsRow: React.FC<FormActionsRowProps> = ({
    left,
    right,
    className,
}) => {
    return (
        <div
            className={clsx(
                'UiFormActionsRow flex w-full items-center justify-between gap-3',
                className
            )}
        >
            <div className={clsx('min-h-[1rem] text-sm text-gray-600')}>
                {left}
            </div>
            <div className={clsx('flex items-center gap-3')}>{right}</div>
        </div>
    )
}

export default UiFormActionsRow
